(function(window, mL, mL_errors, mL_events, mL_config) {
    "use strict";

    var key = 'listrak';

    if (mL_config.do_not_track || !mL_config.tags || !mL_config.tags.listrak) return;

    function que_event(ltkCode) {
        (function(d) {
            if (document.addEventListener) {
                document.addEventListener('ltkAsyncListener', d);
            } else {
                e = document.documentElement;
                e.ltkAsyncProperty = 0;
                e.attachEvent('onpropertychange', function(e) {
                    if (e.propertyName == 'ltkAsyncProperty') {
                        d();
                    }
                });
            }
        })(function() { ltkCode(); });
    }

    function page_item(msg, data) {

        if (!data.item) return console.error(new Error('item is required'));

        var listrak_data = data.item.sku;

        function ltkCode() {
            _ltk_util.ready(function() {
                _ltk.Activity.AddProductBrowse(listrak_data);
            });
        }

        if (typeof _ltk === 'object') {
            ltkCode();
        } else {
            que_event(ltkCode);
        }

        if (mL_config.DEBUG) console.log(key + ' - ' + msg, listrak_data);

    }

    function page(msg, data) {

        function ltkCode() {
            _ltk_util.ready(function() {
                _ltk.Activity.AddPageBrowse();
            });
        }

        if (typeof _ltk === 'object') {
            ltkCode();
        } else {
            que_event(ltkCode);
        }

        if (mL_config.DEBUG) console.log(key + ' - ' + msg);

    }

    function update_items(items, msg) {

        if (items.length < 1) {

            _ltk.SCA.ClearCart();

            if (mL_config.DEBUG) console.log(key + ' - ' + msg + ' - SCA.ClearCart');

            return;
        }

        function add_item(item) {
            if (item.TYPE === 'charge') return;

            var listrak_data = [item.sku, item.quantity, item.rate, item.storedisplayname, 'https://img.mlahart.com/' + item.sku + '.s1.600.jpg', '/' + item.custitem124];

            _ltk.SCA.AddItemWithLinks(item.sku, item.quantity, item.rate, item.storedisplayname, 'https://img.mlahart.com/' + item.sku + '.s1.600.jpg', '/' + item.custitem124);

            if (mL_config.DEBUG) console.log(key + ' - ' + msg + ' - AddItemWithLinks - listrak_data', listrak_data);

        }

        var i = 0,
            l = items.length;

        for (i; i < l; i += 1) {
            add_item(items[i]);
        }

        _ltk.SCA.Submit();

        if (mL_config.DEBUG) console.log(key + ' - ' + msg + ' - SCA.Submit');
        
    }

    function cart_update_items(msg, data) {

        if (!data.cart_items) return console.error(new Error('cart_items is required'));

        function ltkCode() {
            _ltk_util.ready(function() {
                update_items(data.cart_items, msg);
            });
        }

        if (typeof _ltk === 'object') {
            ltkCode();
        } else {
            que_event(ltkCode);
        }

    }

    function order_confirmation(msg, data) {
        var _order = data.order;

        function ltkCode() {
            _ltk_util.ready(function() {

                _ltk.Order.SetCustomer(_order.email, _order.firstname, _order.lastname);

                if(_order.order_id && _order.order_id.indexOf('-') !== -1){
                    _ltk.Order.OrderNumber = _order.order_id.split('-')[1];
                } else {
                    _ltk.Order.OrderNumber = _order.order_id;
                }
                
                _ltk.Order.Currency = _order.currency;
                _ltk.Order.ItemTotal = parseFloat(_order.summary.discountedsubtotal).toFixed('2');
                _ltk.Order.Meta1 = parseFloat(_order.summary.discounttotal).toFixed('2');
                _ltk.Order.ShippingTotal = parseFloat(_order.summary.shippingcost).toFixed('2');
                _ltk.Order.TaxTotal = parseFloat(_order.summary.taxtotal).toFixed('2');
                _ltk.Order.HandlingTotal = parseFloat(_order.summary.handlingcost).toFixed('2');
                _ltk.Order.OrderTotal = parseFloat(_order.summary.total).toFixed('2');
                _order.items.forEach(function(item) {
                    _ltk.Order.AddItem(item.sku, item.quantity, parseFloat(item.rate).toFixed('2'));
                });
                _ltk.Order.Submit();

            });
        }

        if (typeof _ltk === 'object') {
            ltkCode();
        } else {
            que_event(ltkCode);
        }

        if (mL_config.DEBUG) console.log(key + ' - ' + msg);

    }

    // mL_events.publish('form.subscribe', { event: 'form.subscribe', data: { email: 'email', form: 'Footer Form', firstname: 'firstname', firstname: 'lastname' } });

    function form_subscribe(msg, obj) {
        if (!obj.data || !obj.data.email || !obj.data.form) return;

        var sub_map = {
            'Footer Form': 'footer_signup',
            'Register': 'checkout_register'
        };

        var listrak_key = sub_map[obj.data.form];

        if (!listrak_key) throw new Error('Subscribe called on unknown form ' + obj.data.form);

        var _vals = mL.user.shop() || {};

        _vals.ltkEmail = obj.data.email;

        if (obj.data.lastname) {
            _vals.LastName = obj.data.lastname;
        }

        if (obj.data.firstname) {
            _vals.FirstName = obj.data.firstname;
        }

        function ltkCode() {
            _ltk_util.ready(function() {

                _ltk.SCA.Update('email', obj.data.email);

                if(obj.data.subscribe === false) return;

                _ltk.Signup.New(listrak_key, '', _ltk.Signup.TYPE.DEFAULT);

                for (var n in _vals) {
                    _ltk.Signup.SetValue(listrak_key, n, _vals[n]);
                }

                _ltk.Signup.SetValue(listrak_key, 'ltkSaved', true);

                _ltk.Signup.Subscribe(listrak_key);
            });
        }

        if (typeof _ltk === 'object') {
            ltkCode();
        } else {
            que_event(ltkCode);
        }

        if (mL_config.DEBUG) console.log(key + ' - ' + msg, _vals);

    }

    function form_submit(msg, obj) {

        if (!obj.data || !obj.data.email) return;

        function ltkCode() {
            _ltk_util.ready(function() {
                _ltk.SCA.Update('email', obj.data.email);
            });
        }

        if (typeof _ltk === 'object') {
            ltkCode();
        } else {
            que_event(ltkCode);
        }

        if (mL_config.DEBUG) console.log(key + ' - ' + msg, obj.data.email);

    }

    function page_subscription(msg, data) {
        return (msg === 'page.item') ? page_item(msg, data) : page(msg, data);
    }

    function cart_subscription(msg, data) {
        if (msg === 'cart.remove_item' || msg === 'cart.add_item') {
            return cart_update_items(msg, data);
        } else {
            if (mL_config.DEBUG) console.log(key + ' - ' + msg + ' - this event has not been implemented');
        }
    }

    function order_subscription(msg, data) {
        if (msg === 'order.confirmation') {
            return order_confirmation(msg, data);
        } else {
            if (mL_config.DEBUG) console.log(key + ' - ' + msg + ' - this event has not been implemented');
        }
    }

    function form_subscription(msg, obj) {
        if (msg === 'form.subscribe') {
            return form_subscribe(msg, obj);
        } else if (msg === 'cart.add_item') {
            return form_submit(msg, obj);
        } else {
            if (mL_config.DEBUG) console.log(key + ' - ' + msg + ' - this event has not been implemented');
        }
    }

    mL_events.subscribe('page', page_subscription);
    mL_events.subscribe('cart', cart_subscription);
    mL_events.subscribe('order', order_subscription);
    mL_events.subscribe('form', form_subscription);

    mL.listrak = mL.listrak || {};

    mL.listrak.init = function() {
        if (mL.listrak.is_init || !mL.add_tracker) return false;

        mL.add_tracker('https://cdn.listrakbi.com/scripts/script.js?m=sQ7M6UfUoU8T&v=1', 'ltkSDK');

        mL.listrak.is_init = true;

        if (mL_config.DEBUG) console.log(key + ' - plugin loaded');

    };


}(window, window.mL, window.mL_errors, window.mL_events, window.mL_config));